import { type Feedback, parseFeedback } from "../../../../supabase/functions/beta-feedback/policy";
import { supabase } from "./supabase";

export async function submitBetaFeedback(feedback: Feedback) {
  const body = parseFeedback(feedback);
  if (!supabase) throw new Error("尚未接駁回饋服務。內容仍保留，請稍後再試。");
  const abort = new AbortController();
  const timeout = window.setTimeout(() => abort.abort(), 10_000);
  try {
    const sessionResult = await Promise.race([
      supabase.auth.getSession(),
      new Promise<never>((_, reject) =>
        abort.signal.addEventListener("abort", () => reject(new Error("回饋提交逾時。內容仍保留。")), { once: true }),
      ),
    ]);
    if (sessionResult.error || !sessionResult.data.session)
      throw new Error("請在新分頁重新登入後再提交。回饋內容仍保留。");
    const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/beta-feedback`, {
      method: "POST",
      cache: "no-store",
      redirect: "error",
      signal: abort.signal,
      headers: {
        "Content-Type": "application/json",
        apikey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY!,
        Authorization: `Bearer ${sessionResult.data.session.access_token}`,
      },
      body: JSON.stringify(body),
    });
    if (response.status === 401 || response.status === 403)
      throw new Error("請在新分頁重新登入後再提交。回饋內容仍保留。");
    if (response.status !== 201 || (await response.json()).received !== true)
      throw new Error("暫時未能提交回饋。內容仍保留，請稍後重試。");
  } catch (caught) {
    if (caught instanceof Error && caught.message.includes("內容仍保留")) throw caught;
    throw new Error("暫時未能提交回饋。內容仍保留，請稍後重試。");
  } finally {
    window.clearTimeout(timeout);
  }
}
